import { render, staticRenderFns } from "./SurveyAnswersAcceptanceModal.vue?vue&type=template&id=be7fcc20&scoped=true&"
import script from "./SurveyAnswersAcceptanceModal.vue?vue&type=script&lang=ts&"
export * from "./SurveyAnswersAcceptanceModal.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyAnswersAcceptanceModal.vue?vue&type=style&index=0&id=be7fcc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7fcc20",
  null
  
)

export default component.exports